import { useState } from 'react'

import CheckIcon from 'mdi-react/CheckIcon'
import { useSelector } from 'react-redux'

import { API_ROUTE_SUBSCRIPTION_AUTHORIZATION_MAIL } from '@/api/apiRoutes'
import Button from '@/components/form/Button'
import Input from '@/components/form/Input'
import { Translation } from '@/components/i18n/Translation'
import Success from '@/components/util/feedback/Success'
import LoaderCircle from '@/components/util/LoaderCircle'
import { getSubscriptionOrder } from '@/ducks/subscriptionOrderReducer'
import { post } from '@/util/auth'

import './resend-auth-mail.scss'

const ResendAuthMailPrompt = () => {
  const order = useSelector(getSubscriptionOrder)

  const [email, setEmail] = useState(order.email)
  const [isSent, setIsSent] = useState(false)
  const [isSending, setIsSending] = useState(false)
  // @ts-ignore
  const onSubmit = async e => {
    e.preventDefault()
    setIsSending(true)

    const payload = { email }

    try {
      await post(API_ROUTE_SUBSCRIPTION_AUTHORIZATION_MAIL.replace(':order_id', order.id), payload)
      setIsSent(true)
    } catch {}
    setIsSending(false)
  }

  return (
    <form onSubmit={onSubmit} className="resend-auth-mail">
      <h2>
        <Translation id="Resend authorization mail" />
      </h2>

      {isSending && <LoaderCircle />}

      {isSent && (
        <Success>
          <CheckIcon style={{ marginRight: '.5rem' }} />
          <Translation id="Authorization sent to {email}" email={email} />
        </Success>
      )}

      <Input
        label={<Translation id="E-mail" />}
        value={email}
        disabled={isSent || isSending}
        onChange={e => setEmail(e.target.value)}
      />

      <Button disabled={isSent || isSending}>
        <Translation id="Send" />
      </Button>
    </form>
  )
}

export default ResendAuthMailPrompt
